import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BookOpenIcon, CheckIcon, ClockIcon, AwardIcon, ShieldCheckIcon, ChevronRightIcon, CheckCircleIcon, ArrowRightIcon, GraduationCapIcon, AlertCircleIcon, ScrollIcon, UsersIcon, FileTextIcon, ClipboardCheckIcon, ThermometerIcon, UtensilsIcon, BugIcon, BadgeCheckIcon } from 'lucide-react';
export const SEOTestPage = () => {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-4197">
      <Header data-id="element-4198" />
      <main className="flex-grow" data-id="element-4199">
        <HeroSection data-id="element-4200" />
        <WhyThisCourseSection data-id="element-4201" />
        <LearningOutcomesSection data-id="element-4202" />
        <TargetAudienceSection data-id="element-4203" />
        <FormatSection data-id="element-4204" />
        <CertificationSection data-id="element-4205" />
        <NextStepsSection data-id="element-4206" />
        <CtaSection data-id="element-4207" />
      </main>
      <Footer data-id="element-4208" />
    </div>;
};
const HeroSection = () => {
  return <section className="relative pt-28 pb-20 md:pt-32 md:pb-24 bg-gradient-to-b from-emerald-950 to-emerald-900 overflow-hidden" data-id="element-4209">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-4210">
        <div className="absolute top-1/4 -right-24 w-96 h-96 rounded-full bg-emerald-600/20 blur-3xl" data-id="element-4211"></div>
        <div className="absolute bottom-1/3 -left-24 w-80 h-80 rounded-full bg-emerald-400/10 blur-3xl" data-id="element-4212"></div>
      </div>
      {/* Pattern overlay */}
      <div className="absolute inset-0 opacity-5 mix-blend-overlay" data-id="element-4213">
        <div className="absolute inset-0" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
        backgroundSize: '24px 24px'
      }} data-id="element-4214"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-4215">
        <div className="max-w-4xl mx-auto text-center" data-id="element-4216">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6 shadow-lg" data-id="element-4217">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300 mr-2" data-id="element-4218" />
            <span className="text-white/90 text-sm font-medium" data-id="element-4219">
              FSAI Compliant Training
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-white leading-tight" data-id="element-4220">
            HACCP Level 1 Food Safety Training{' '}
            <span className="text-emerald-300" data-id="element-4221">(Ireland)</span>
          </h1>
          <p className="text-xl text-white/90 mb-10 leading-relaxed" data-id="element-4222">
            The Kivarro HACCP Level 1 Food Safety Training course is the
            essential induction programme for food handlers in Ireland. Fully
            aligned with Food Safety Authority of Ireland (FSAI) guidelines,
            this accredited online course gives you the practical skills to
            prevent contamination, protect customers, and meet your legal
            obligations under Irish food law.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-4223">
            <a href="#enroll" className="px-6 py-3.5 bg-emerald-500 hover:bg-emerald-600 text-white font-medium rounded-lg transition-all duration-300 text-center shadow-lg flex items-center justify-center group" data-id="element-4224">
              Enroll Now - Just €19
              <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-4225" />
            </a>
            <a href="#learn-more" className="px-6 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-medium rounded-lg border border-white/20 transition-all duration-300 text-center shadow-lg" data-id="element-4226">
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>;
};
const WhyThisCourseSection = () => {
  return <section id="why-this-course" className="py-20 bg-white" data-id="element-4227">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4228">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-4229">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-4230">
            <CheckCircleIcon className="h-8 w-8 text-emerald-600" data-id="element-4231" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-4232">
            Why This Course?
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-4233">
          {[{
          icon: <ScrollIcon className="h-7 w-7 text-emerald-600" data-id="element-4234" />,
          title: 'Mandatory in Ireland',
          description: 'Training commensurate with work activity (FSAI).'
        }, {
          icon: <ClockIcon className="h-7 w-7 text-emerald-600" data-id="element-4235" />,
          title: 'Timeline',
          description: 'Stage I must be completed before food handling begins; Stage II within 1 month of starting work.'
        }, {
          icon: <AwardIcon className="h-7 w-7 text-emerald-600" data-id="element-4236" />,
          title: 'Accredited & Recognised',
          description: 'Trusted by Irish employers, Environmental Health Officers (EHOs) and food safety inspectors.'
        }, {
          icon: <BookOpenIcon className="h-7 w-7 text-emerald-600" data-id="element-4237" />,
          title: '100% Online',
          description: 'Self-paced modules, mobile friendly, 24/7 access.'
        }, {
          icon: <ClipboardCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-4238" />,
          title: 'Assessment',
          description: 'Short quizzes + final test with unlimited retakes.'
        }, {
          icon: <BadgeCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-4239" />,
          title: 'Instant Certification',
          description: 'Digital certificate on completion.'
        }].map((item, index) => <div key={index} className="bg-white/90 backdrop-blur-sm rounded-xl p-8 shadow-lg border border-emerald-50 hover:shadow-xl transition-shadow duration-300" data-id="element-4240">
              <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-6" data-id="element-4241">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-4242">
                {item.title}
              </h3>
              <p className="text-gray-600" data-id="element-4243">{item.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
const LearningOutcomesSection = () => {
  return <section id="learning-outcomes" className="py-20 bg-gray-50" data-id="element-4244">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4245">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-4246">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-4247">
            <GraduationCapIcon className="h-8 w-8 text-emerald-600" data-id="element-4248" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-4249">
            What You'll Learn (Level 1 Outcomes)
          </h2>
        </div>
        <div className="max-w-6xl mx-auto" data-id="element-4250">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4251">
            {[{
            icon: <FileTextIcon className="h-7 w-7 text-emerald-600" data-id="element-4252" />,
            title: 'Food Safety Fundamentals',
            description: 'Food safety vs. food hygiene; legal duties in Ireland.'
          }, {
            icon: <CheckIcon className="h-7 w-7 text-emerald-600" data-id="element-4253" />,
            title: 'Personal Hygiene',
            description: 'Handwashing & personal hygiene; hygienic uniforms/PPE.'
          }, {
            icon: <ShieldCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-4254" />,
            title: 'Contamination Prevention',
            description: 'Preventing contamination & cross-contamination (raw/cooked segregation, colour-coding).'
          }, {
            icon: <ThermometerIcon className="h-7 w-7 text-emerald-600" data-id="element-4255" />,
            title: 'Temperature Control',
            description: 'Storage, cooking, hot/cold holding, delivery checks.'
          }, {
            icon: <UtensilsIcon className="h-7 w-7 text-emerald-600" data-id="element-4256" />,
            title: 'Cleaning & Sanitising',
            description: '"Clean-as-you-go" and safe chemical use.'
          }, {
            icon: <ClipboardCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-4257" />,
            title: 'HACCP Principles',
            description: 'Basic HACCP principles (hazards, controls, records) at Level 1 awareness.'
          }, {
            icon: <AlertCircleIcon className="h-7 w-7 text-emerald-600" data-id="element-4258" />,
            title: 'Allergen Management',
            description: 'Allergens overview (14 EU-listed allergens) and safe communication.'
          }, {
            icon: <BugIcon className="h-7 w-7 text-emerald-600" data-id="element-4259" />,
            title: 'Pest Control',
            description: 'Pest awareness and reporting procedures.'
          }, {
            icon: <ClipboardCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-4260" />,
            title: 'Documentation',
            description: 'Delivery checks, record-keeping, and cooperating with EHOs.'
          }].map((item, index) => <div key={index} className="bg-white/90 backdrop-blur-sm rounded-xl p-8 shadow-lg border border-emerald-50 hover:shadow-xl transition-shadow duration-300" data-id="element-4261">
                <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-6" data-id="element-4262">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-4263">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-4264">{item.description}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
const TargetAudienceSection = () => {
  return <section id="target-audience" className="py-20 bg-white" data-id="element-4265">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4266">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-4267">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-4268">
            <UsersIcon className="h-8 w-8 text-emerald-600" data-id="element-4269" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-4270">
            Who Should Take This Course?
          </h2>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-4271">
          <div className="bg-emerald-50 rounded-2xl p-8 shadow-lg" data-id="element-4272">
            <p className="text-xl text-gray-700 leading-relaxed" data-id="element-4273">
              Kitchen porters, wait staff, deli/counter staff, baristas,
              catering crews, retail food handlers and any new employee who
              handles food in restaurants, cafés, hotels, bars, takeaways,
              catering, retail, and food production in Ireland.
            </p>
            <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-4274">
              {['Restaurants', 'Cafés', 'Hotels', 'Bars', 'Takeaways', 'Catering', 'Retail', 'Food Production'].map((venue, index) => <div key={index} className="flex items-center" data-id="element-4275">
                  <CheckCircleIcon className="h-5 w-5 text-emerald-500 mr-2" data-id="element-4276" />
                  <span className="text-gray-700" data-id="element-4277">{venue}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const FormatSection = () => {
  return <section id="format" className="py-20 bg-gray-50" data-id="element-4278">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4279">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-4280">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-4281">
            <BookOpenIcon className="h-8 w-8 text-emerald-600" data-id="element-4282" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-4283">
            Format & Assessment
          </h2>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-4284">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-4285">
            {[{
            icon: <BookOpenIcon className="h-7 w-7 text-emerald-600" data-id="element-4286" />,
            title: 'Bite-sized Lessons',
            description: 'Video lessons + short knowledge checks.'
          }, {
            icon: <ClipboardCheckIcon className="h-7 w-7 text-emerald-600" data-id="element-4287" />,
            title: 'Final Assessment',
            description: 'Online test (minimum 70% to pass) with unlimited free retakes.'
          }, {
            icon: <DevicesIcon className="h-7 w-7 text-emerald-600" data-id="element-4288" />,
            title: 'Multi-device Access',
            description: 'Accessible on desktop, tablet, and mobile (captions included).'
          }].map((item, index) => <div key={index} className="bg-white rounded-xl p-8 shadow-lg border border-emerald-50" data-id="element-4289">
                <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mb-6" data-id="element-4290">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-4291">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-4292">{item.description}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
const CertificationSection = () => {
  return <section id="certification" className="py-20 bg-white" data-id="element-4293">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4294">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-4295">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-4296">
            <AwardIcon className="h-8 w-8 text-emerald-600" data-id="element-4297" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-4298">
            Certification (Ireland)
          </h2>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-4299">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-4300">
            <div data-id="element-4301">
              <img src="https://images.unsplash.com/photo-1577301656525-dbed2a0afc20?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="HACCP Food Safety Certificate" className="rounded-xl shadow-xl border-4 border-emerald-50" data-id="element-4302" />
            </div>
            <div data-id="element-4303">
              <div className="space-y-6" data-id="element-4304">
                <div className="flex items-start" data-id="element-4305">
                  <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-4306">
                    <BadgeCheckIcon className="h-5 w-5 text-emerald-600" data-id="element-4307" />
                  </div>
                  <div data-id="element-4308">
                    <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-4309">
                      Accredited Certificate
                    </h3>
                    <p className="text-gray-600" data-id="element-4310">
                      Level 1 Food Safety certificate aligned to FSAI guidance.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-4311">
                  <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-4312">
                    <DownloadIcon className="h-5 w-5 text-emerald-600" data-id="element-4313" />
                  </div>
                  <div data-id="element-4314">
                    <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-4315">
                      Instant Download
                    </h3>
                    <p className="text-gray-600" data-id="element-4316">
                      Instant PDF download and secure verification link for
                      employers.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-4317">
                  <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-4318">
                    <ClockIcon className="h-5 w-5 text-emerald-600" data-id="element-4319" />
                  </div>
                  <div data-id="element-4320">
                    <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-4321">
                      Validity Period
                    </h3>
                    <p className="text-gray-600" data-id="element-4322">
                      Refresher recommended every 2–3 years, or sooner if your
                      role, procedures, or law changes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const NextStepsSection = () => {
  return <section id="next-steps" className="py-20 bg-gray-50" data-id="element-4323">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4324">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-4325">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-6" data-id="element-4326">
            <ArrowRightIcon className="h-8 w-8 text-emerald-600" data-id="element-4327" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-4328">
            What's Next? (Level 2 Requirement)
          </h2>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-4329">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-emerald-50" data-id="element-4330">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-4331">
              <div className="w-full md:w-1/3" data-id="element-4332">
                <div className="w-24 h-24 mx-auto rounded-full bg-emerald-100 flex items-center justify-center" data-id="element-4333">
                  <GraduationCapIcon className="h-12 w-12 text-emerald-600" data-id="element-4334" />
                </div>
              </div>
              <div className="w-full md:w-2/3" data-id="element-4335">
                <p className="text-xl text-gray-700 leading-relaxed" data-id="element-4336">
                  If you prepare or handle open or high-risk foods, you must
                  progress to HACCP Level 2 (legally required in Ireland). Level
                  1 provides the foundation for that training.
                </p>
                <div className="mt-6" data-id="element-4337">
                  <a href="/courses/haccp-level-2" className="inline-flex items-center text-emerald-600 font-medium hover:text-emerald-700" data-id="element-4338">
                    Learn more about HACCP Level 2 training
                    <ChevronRightIcon className="ml-1 h-5 w-5" data-id="element-4339" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CtaSection = () => {
  return <section id="enroll" className="py-20 bg-emerald-900 relative overflow-hidden" data-id="element-4340">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-4341">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-emerald-600/20 blur-3xl" data-id="element-4342"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 rounded-full bg-emerald-400/10 blur-3xl" data-id="element-4343"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-4344">
        <div className="max-w-4xl mx-auto text-center" data-id="element-4345">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-4346">
            Start Your HACCP Level 1 Food Safety Training Today
          </h2>
          <p className="text-xl text-white/80 mb-10 max-w-3xl mx-auto" data-id="element-4347">
            Protect your customers, meet Irish legal requirements, and get
            certified online with Kivarro.
          </p>
          <a href="/checkout" className="px-8 py-4 bg-white hover:bg-gray-100 text-emerald-700 font-bold rounded-lg transition-all duration-300 shadow-lg inline-flex items-center" data-id="element-4348">
            👉 Enroll Now
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-4349" />
          </a>
          <div className="mt-10 flex flex-wrap justify-center gap-10" data-id="element-4350">
            <div className="flex flex-col items-center" data-id="element-4351">
              <div className="text-white/80 mb-2" data-id="element-4352">Instant Access</div>
              <div className="text-white font-medium" data-id="element-4353">Start Today</div>
            </div>
            <div className="flex flex-col items-center" data-id="element-4354">
              <div className="text-white/80 mb-2" data-id="element-4355">Fully Accredited</div>
              <div className="text-white font-medium" data-id="element-4356">FSAI Aligned</div>
            </div>
            <div className="flex flex-col items-center" data-id="element-4357">
              <div className="text-white/80 mb-2" data-id="element-4358">Secure Payment</div>
              <div className="text-white font-medium" data-id="element-4359">256-bit SSL</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
// Helper component for multi-device icon
const DevicesIcon = ({
  className
}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-4360">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" data-id="element-4361" />
      <path d="M12 18h.01" data-id="element-4362" />
      <rect x="1" y="8" width="4" height="8" rx="1" ry="1" data-id="element-4363" />
      <rect x="19" y="8" width="4" height="8" rx="1" ry="1" data-id="element-4364" />
    </svg>;
};
// Helper component for download icon
const DownloadIcon = ({
  className
}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-4365">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-id="element-4366" />
      <polyline points="7 10 12 15 17 10" data-id="element-4367" />
      <line x1="12" y1="15" x2="12" y2="3" data-id="element-4368" />
    </svg>;
};